import { commas } from '../../utils/common';
import { locale } from '../../utils/i18n';
import { RupeeSymbol } from '../rupeeSymbol';

const ConvenienceHelp = ({ convChargeDetails }) => {
  const varyAmount = {
    NET_BANKING: locale('pcf.nb'),
    CREDIT_CARD: locale('pcf.cc')
  };

  return (
    <div
      class={`ptm-body-bg ptm-ttp ptm-white-bg ptm-pos-a ptm-ttp-bottom popup-global cnvc-before-icon`}
    >
      <label class={`ptm-ccl ptm-d-block ptm-body-color`}>{locale('pcf.convenience.charge')}</label>
      <ul class={`ptm-details sub-txt-global`}>
        {Object.keys(convChargeDetails).map(data => (
          <li class={`ptm-w100-ib ptm-vt ptm-body-color`}>
            <div class="ptm-left ptm-body-color">
              {convChargeDetails[data].displayText}
              {varyAmount[data] && <span className={`ptm-body-color`}>*</span>}
              {varyAmount[data] && (
                <div class={`ptm-apx-amnt ptm-max-150 sub-txt-global ptm-body-color`}>
                  <span className={`ptm-body-color`}>*</span>
                  {varyAmount[data]}
                </div>
              )}
            </div>
            <div class="ptm-right ptm-body-color">
              <RupeeSymbol />{' '}
              <span class={`ptm-semibold ptm-body-color`}>
                {commas(
                  convChargeDetails[data].feeAmount.value.indexOf('.') >= 0
                    ? `${convChargeDetails[data].feeAmount.value.split('.')[0]}`
                    : convChargeDetails[data].feeAmount.value
                )}
              </span>
              {convChargeDetails[data].feeAmount.value.indexOf('.') >= 0 ? (
                <span class={`sub-txt-global ptm-body-color`}>
                  .{convChargeDetails[data].feeAmount.value.split('.')[1]}
                </span>
              ) : null}
              + GST {locale('pcf.applicable')}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ConvenienceHelp;



// WEBPACK FOOTER //
// ./components/convHelp/index.js